/* Click-and-hold scrolling for the horizontal rails in the gift popup.
 *
 * On a phone these rails scroll by touch; with a mouse there is nothing to grab — no visible
 * scrollbar (deliberately: a bar under 44px circles reads as a defect) and no wheel axis, so on
 * desktop the row simply looked stuck. This adds the drag people already expect from a carousel.
 *
 * It attaches by BEHAVIOUR, not by class: any element inside the popup that actually overflows
 * horizontally gets it. That way it keeps working when a rail is renamed or a new one is added,
 * and it never touches an element that has nothing to scroll.
 */
(function () {
  var SCOPE = ".gcp-dialog, .gcp-wrap, #gcp-ladder, .cart-drawer, #CartDrawer";

  /* The computed overflow first, the sizes only for the few that can scroll sideways (25 Sept).
     Reading scrollWidth/clientWidth forces layout, and this read it for every element in the drawer
     and the gift dialog on every DOM change - measured 60ms per pass on a phone-speed CPU, 518ms
     as the drawer opened. */
  function scrollable(el) {
    if (el.getAttribute("data-ntf-drag")) return false;
    var ox = getComputedStyle(el).overflowX;
    if (ox !== "auto" && ox !== "scroll") return false;
    return el.scrollWidth > el.clientWidth + 8;
  }

  function attach(el) {
    el.setAttribute("data-ntf-drag", "1");
    var down = false, startX = 0, startLeft = 0, moved = 0;

    el.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "touch") return;      // touch already works; leave it alone
      down = true; moved = 0;
      startX = e.clientX; startLeft = el.scrollLeft;
      el.style.cursor = "grabbing";
    });

    el.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      el.scrollLeft = startLeft - dx;
      /* Only once the drag is real: preventDefault on every move would kill ordinary clicks on
         the swatches inside the rail. */
      if (moved > 4) e.preventDefault();
    });

    function end(e) {
      if (!down) return;
      down = false;
      el.style.cursor = "";
      /* A drag must not also fire the click underneath it — otherwise dragging the rail past a
         swatch selects that swatch. Swallow exactly one click, and only after a real drag. */
      if (moved > 4) {
        el.addEventListener("click", function once(ev) {
          ev.stopPropagation(); ev.preventDefault();
          el.removeEventListener("click", once, true);
        }, true);
      }
    }
    el.addEventListener("pointerup", end);
    el.addEventListener("pointercancel", end);
    el.addEventListener("pointerleave", end);

    if (!el.style.cursor) el.style.cursor = "grab";
  }

  /* Site speed, 17 Oct 2026 (desktop INP): rails are found when the mouse comes over them, not by a scan.
     The scan read the computed style of every element in the drawer and the gift popup on EVERY DOM change
     anywhere on the page (the shared NTF_ON_MUTATE pass, which runs in the frame right before paint):
     measured on a desktop product page 28 passes, 428 ms in 13 s, up to 65 ms each, and the 65 ms landed in
     the paint after a click, i.e. straight into INP. A rail can only be grabbed once the pointer is over it,
     so checking the hovered element and its parents up to the popup/drawer attaches the same rails, with the
     same grab cursor, at the moment it matters. A rail that was not overflowing yet is checked again on the
     next hover, as the scan re-checked it on the next change. */
  function over(e) {
    if (e.pointerType === "touch") return;
    var t = e.target, root = t && t.closest ? t.closest(SCOPE) : null;
    if (!root) return;
    for (var el = t; el && el.nodeType === 1; el = el.parentElement) {
      if (el.getAttribute("data-ntf-drag")) return;   // already attached: nothing to look for
      if (scrollable(el)) { attach(el); return; }
      if (el === root) return;
    }
  }

  /* Mouse and trackpad only: touch already scrolls these rails ("touch already works; leave it
     alone" - pointerdown above), so on a phone this whole pass was cost with nothing to attach. */
  var mouse = false;
  try { mouse = window.matchMedia("(any-hover:hover) and (any-pointer:fine)").matches; } catch (e) {}
  if (!mouse) return;
  document.addEventListener("pointerover", over, { passive: true });
})();
